export enum TipoPadron {
    Ninguno,
    ARBAPercepciones,
    CABA,
    Cordoba,
    LaPlata,
    Misiones,
    ARBAPercepcionesCombustibles,
    PercepcionIVARG17,
    PercepcionIVARG18,
    Jujuy,
    Tucuman
}

export enum TipoRegimenARBA {
    General = "G",
    Combustibles = "C"
}
